import formatMinutesToReadable from "../components/reusableComps/formatDays/formatDays";

export const renderAbsenceInfo = (absence) => {
  if (absence.is_half_day) {
    return `${absence.absence_type} (meio dia)`;
  }

  const timeFormatted = formatMinutesToReadable(absence.total_minutes);
  return `${absence.absence_type} (${timeFormatted})`;
};
export const renderAbsenceDate = (absence) => {
  if (!absence.start_date || !absence.end_date) return "";

  const start = new Date(absence.start_date);
  const end = new Date(absence.end_date);

  const getShortMonth = (d) => {
    let m = d.toLocaleString("pt-PT", { month: "short" }).replace(".", "");
    return m.charAt(0).toUpperCase() + m.slice(1);
  };

  const startMonth = getShortMonth(start);
  const startDay = String(start.getDate()).padStart(2, "0");
  const startYear = start.getFullYear();

  if (start.toDateString() === end.toDateString()) {
    if (absence.is_half_day) {
      const startTime =
        absence.start_time?.slice(0, 5) ||
        new Date(absence.start_date).toISOString().slice(11, 16);

      const endTime =
        absence.end_time?.slice(0, 5) ||
        new Date(absence.end_date).toISOString().slice(11, 16);

      return `${startMonth} ${startDay} ${startYear} (${startTime} - ${endTime})`;
    }
    return `${startMonth} ${startDay} ${startYear}`;
  }

  const endMonth = getShortMonth(end);
  const endDay = String(end.getDate()).padStart(2, "0");
  const endYear = end.getFullYear();

  if (startYear === endYear) {
    return `${startMonth} ${startDay} - ${endMonth} ${endDay} ${startYear}`;
  }

  return `${startMonth} ${startDay} ${startYear} - ${endMonth} ${endDay} ${endYear}`;
};
